import { $t } from '@/i18n';
import { ApprovalOperation } from '@/services/flow';
const getFlowSchema = () => ({
    id: 'flow',
    title: $t('k_1d522a5f'),
    type: 'object',
    readonly: true,
    'uc:collapsed': true,
    'uc:bindable': false,
    methods: [
        {
            id: 'fetchJob',
            title: $t('k_62c780f5'),
            arguments: [{ id: 'jobId', type: 'string', description: $t('k_4876b2f7') }],
        },
        {
            id: 'approval',
            title: $t('k_3e9b02f0'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_4876b2f7') },
                { id: 'nodeId', type: 'string', description: $t('k_171f4a68') },
                {
                    id: 'operation', type: 'string', description: $t('k_279f7fb6'), enum: ApprovalOperation,
                },
                { id: 'comment', type: 'string', description: $t('k_b18fa4f2') },
                { id: 'form', type: 'object', description: $t('k_7e41b35c') }
            ],
        },
        {
            id: 'startFlow',
            title: $t('k_cd38bccc'),
            arguments: [
                { id: 'flowId', type: 'string', description: $t('k_4876b2f7') },
                { id: 'params', type: 'object', description: $t('k_6faa5926') },
            ],
        },
        {
            id: 'fetchFlow',
            title: $t('k_9047817e'),
            arguments: [{ id: 'flowId', type: 'string', description: $t('k_4876b2f7') }],
        },
        {
            id: 'fetchApprovalNodeInfo',
            title: $t('k_16a7ee42'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_4876b2f7') },
                { id: 'nodeId', type: 'string', description: $t('k_171f4a68') }
            ],
        },
        {
            id: 'fetchLogNodeInfo',
            title: $t('k_cb6d514f'),
            arguments: [
                { id: 'jobId', type: 'string', description: $t('k_4876b2f7') },
                { id: 'nodeId', type: 'string', description: $t('k_171f4a68') }
            ],
        },
        {
            id: 'fetchJobList',
            title: $t('k_a7ef3e87'),
            arguments: [
                { id: 'title', title: $t('k_10eb0273'), type: 'string', description: $t('k_69738fe5') },
                { id: 'creator', title: $t('k_6cf18673'), type: 'string', description: $t('k_28f4b25a') }
            ],
        },
        {
            id: 'fetchJobListByType',
            title: $t('k_74c6885e'),
            arguments: [
                { id: 'title', title: $t('k_10eb0273'), type: 'string', description: $t('k_69738fe5') },
                {
                    id: 'type', title: $t('k_b809779'), type: 'string', description: $t('k_b809779'), enum: [{
                            label: $t('k_3aff6028'),
                            value: 'created',
                        }, {
                            label: $t('k_a5c4ef48'),
                            value: 'participated',
                        },
                        {
                            label: $t('k_d2e41051'),
                            value: 'related',
                        },
                        {
                            label: $t('k_619e3485'),
                            value: 'pending',
                        }],
                }
            ],
        },
    ],
});
export default getFlowSchema;
